import { BaseComponent } from 'src/app/shared/components/base.component';
import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertSummaryService, NestedAlertSummaryService, DoubleNestedAlertSummaryService } from 'src/core/services/alert-summary.service';
import { takeUntil } from 'rxjs/operators';
import { alertSummuryFader } from 'src/app/route-animations';
import { AuthenticationService } from 'src/core/http/authentication.service';


@Component({
  selector: 'app-alert-summary',
  templateUrl: './alert-summary.component.html',
  styleUrls: ['./alert-summary.component.scss'],
  animations: [
    alertSummuryFader
  ]
})
export class AlertSummaryComponent extends BaseComponent implements OnInit  {

  isInNestedViewYN = false;

  constructor(
    public alertSummaryService: AlertSummaryService,
    protected authenticationService: AuthenticationService,
    ) {
    super(authenticationService);
  }

  ngOnInit() {
    this.alertSummaryService.message$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(message => {

        if (message !== null) {
          // Scroll to top
          document.querySelector('.mat-drawer-content').scrollTo(0, 0);
        }
    });
  }

  close() {
    this.alertSummaryService.clear();
  }

}



@Component({
  selector: 'app-nested-alert-summary',
  templateUrl: './alert-summary.component.html',
  styleUrls: ['./alert-summary.component.scss'],
  animations: [
    alertSummuryFader
  ]
})
export class NestedAlertSummaryComponent extends BaseComponent implements OnInit  {

  isInNestedViewYN = true;

  constructor(
    public alertSummaryService: NestedAlertSummaryService,
    protected authenticationService: AuthenticationService) {
    super(authenticationService);
  }

  ngOnInit() {

    this.alertSummaryService.message$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(message => {

        if (message !== null) {
          // Scroll to top
          setTimeout(() => { // Necessary due, to slidein animation
            const slideinList = document.querySelectorAll('.slidein');
            if (slideinList && slideinList.length > 0) {
              slideinList[slideinList.length - 1].scrollTo(0, 0);
            }
          });
      }
    });
  }

  close() {
    this.alertSummaryService.clear();
  }

}



@Component({
  selector: 'app-double-nested-alert-summary',
  templateUrl: './alert-summary.component.html',
  styleUrls: ['./alert-summary.component.scss'],
  animations: [
    alertSummuryFader
  ]
})
export class DoubleNestedAlertSummaryComponent extends BaseComponent implements OnInit  {

  isInNestedViewYN = true;

  constructor(
    public alertSummaryService: DoubleNestedAlertSummaryService,
    protected authenticationService: AuthenticationService) {
    super(authenticationService);
  }

  ngOnInit() {

    this.alertSummaryService.message$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(message => {

        if (message !== null) {
          // Scroll to top
          setTimeout(() => { // Necessary due, to slidein animation
            const slideinList = document.querySelectorAll('.slidein');
            if (slideinList && slideinList.length > 0) {
              slideinList[slideinList.length - 1].scrollTo(0, 0);
            }
          });
      }
    });
  }

  close() {
    this.alertSummaryService.clear();
  }

}
